export default function listenDOM(element, event, handler, useCapture) {
  element.addEventListener(event, handler, useCapture);

  return () => {
    element.removeEventListener(event, handler, useCapture);
  };
}



/** WEBPACK FOOTER **
 ** ./src/logic/listenDOM.js
 **/